import { render, staticRenderFns } from "./goodsImportTask.vue?vue&type=template&id=387a3867&scoped=true&"
import script from "./goodsImportTask.vue?vue&type=script&lang=js&"
export * from "./goodsImportTask.vue?vue&type=script&lang=js&"
import style0 from "./goodsImportTask.vue?vue&type=style&index=0&id=387a3867&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387a3867",
  null
  
)

export default component.exports